import {EzHeading} from '@ezcater/recipe';
import LoadingSpinner from 'components/LoadingSpinner';
import DeliveryCard from 'components/DeliveryCard';
import type {
  CompletedDeliveriesAssignmentsQuery,
  MyDeliveriesAssignmentsQuery,
} from 'services/graphql/types';
import {CardContainer} from './DeliveryCardContainer.styles';

type MyDeliveriesQueryNodes = NonNullable<
  NonNullable<MyDeliveriesAssignmentsQuery['me']>['driverAccount']
>['assignments']['nodes'];
type CompletedDeliveriesQueryNodes = NonNullable<
  NonNullable<CompletedDeliveriesAssignmentsQuery['me']>['driverAccount']
>['assignments']['nodes'];

interface DeliveryCardProps {
  assignments?: MyDeliveriesQueryNodes | CompletedDeliveriesQueryNodes;
  loading: boolean;
  header: string;
}

const DeliveryCardContainer = ({assignments, loading, header}: DeliveryCardProps) => (
  <CardContainer>
    <EzHeading size="2">{header}</EzHeading>
    {loading && !assignments && <LoadingSpinner />}
    {!loading && assignments && (
      <>
        {assignments.length === 0 && <p>No Deliveries Available</p>}
        {assignments.length >= 1 &&
          assignments.map(driverAssignment => (
            <DeliveryCard key={driverAssignment.id} assignment={driverAssignment} />
          ))}
      </>
    )}
  </CardContainer>
);

export default DeliveryCardContainer;
